import { render, staticRenderFns } from "./Pozos.vue?vue&type=template&id=2083952a&"
import script from "./Pozos.vue?vue&type=script&lang=js&"
export * from "./Pozos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports